// extracted by mini-css-extract-plugin
export var closeButton = "_5x-0";